import { newAPI } from 'services';
import qs from 'qs';

export const fetchEventConfig = async (userId, establishmentId, options = {}) => {
  const response = await newAPI.get(
    `${userId}/establishment/${establishmentId}/event_scheduling/settings/view`,
    { silenceErrorToast: !!options?.silenceErrorToast }
  );
  return response.data;
}

export const createEventConfig = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/event_scheduling/settings/new`, qs.stringify(params));
  return response.data;
}

export const updateEventConfig = async (userId, establishmentId, params) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/event_scheduling/settings/update`, qs.stringify(params));
  return response.data;
}